__turbopack_context__.v({
  "blobDesktop": "ErrorState-module-scss-module__sorFtG__blobDesktop",
  "blobMobile": "ErrorState-module-scss-module__sorFtG__blobMobile",
  "copy": "ErrorState-module-scss-module__sorFtG__copy",
  "headline": "ErrorState-module-scss-module__sorFtG__headline",
  "headlineWrapper": "ErrorState-module-scss-module__sorFtG__headlineWrapper",
  "page": "ErrorState-module-scss-module__sorFtG__page",
  "retryButton": "ErrorState-module-scss-module__sorFtG__retryButton",
  "stopStickerPosition": "ErrorState-module-scss-module__sorFtG__stopStickerPosition",
});
